"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DetailsAssetsModal = void 0;
var DetailsAssetsModal_1 = require("./DetailsAssetsModal");
Object.defineProperty(exports, "DetailsAssetsModal", { enumerable: true, get: function () { return DetailsAssetsModal_1.DetailsAssetsModal; } });
